export enum NotificationAuthorizations {
  ANNOUNCEMENT = 'ANNOUNCEMENT',
  COMMENT_ACTIVITY = 'COMMENT_ACTIVITY',
  MESSAGE = 'MESSAGE',
  NEW_SUBJECTS = 'NEW_SUBJECTS',
  SURVEY = 'SURVEY',
  EVENT = 'EVENT',
}
